(() => {
    class Request extends App.Entities.Base {
        constructor(Instance = null) {
            super();

            // Supported Content-Types
            this.CONTENT_TYPE_HTML  = 'text/html';
            this.CONTENT_TYPE_XML   = 'application/xml';
            this.CONTENT_TYPE_JSON  = 'application/json';

            // Values
            this.Instance       = Instance; // Use Instances callbacks
            this._url           = null;
            this._method        = App.Interface.Api.METHOD_GET;
            this._data          = {};
            this._cache         = true;
            this._async         = true;
            this._headers       = {};
            this._contentType   = 'application/x-www-form-urlencoded; charset=UTF-8';
            this._dataType      = 'json';
            this._converters    = {};
            this._accepts       = {
                dynamic: [
                    this.CONTENT_TYPE_JSON,
                    this.CONTENT_TYPE_XML,
                    this.CONTENT_TYPE_HTML,
                ].join(', '),
            };
        }

        get url() {
            return this._url;
        }

        set url(url) {
            this._url = url;
            return this;
        }

        get method() {
            return this._method;
        }

        set method(method) {
            this._method = method;
            return this;
        }

        get data() {
            return this._data;
        }

        set data(data) {
            this._data = data;
            return this;
        }

        get dataType() {
            return this._dataType;
        }

        set dataType(dataType) {
            this._dataType = dataType;
            return this;
        }

        get cache() {
            return this._cache;
        }

        set cache(cache) {
            this._cache = cache;
            return this;
        }

        get async() {
            return this._async;
        }

        set async(async) {
            this._async = async;
            return this;
        }

        setHeader(key, value) {
            this._headers[key] = value;
        }

        get headers() {
            return this._headers;
        }

        get contentType() {
            return this._contentType;
        }

        set contentType(contentType) {
            this._contentType = contentType;
            return this;
        }

        /* GETTERS */
        get accepts() {
            return this._accepts;
        }

        get converters() {
            return {
                'text dynamic': result => {
                    try {
                        return JSON.parse(result);
                    } catch(e) {
                        return result;
                    }
                }
            };
        }

        objectify() {
            let obj = super.objectify();
            obj.url         = this.url; // todo: get the super.url while objectify
            obj.converters  = this.converters;
            if (this.Instance) obj.statusCode = this.Instance.statusCode || {};
            return obj;
        }

        call() {
            return $.ajax(this.objectify())
                // Response has content
                .done(response => {
                    this.response = response;
                    if (this.Instance && this.Instance.done)
                        this.Instance.done(this);
                })
                // Response is empty
                .fail(response => {
                    this.response = response;
                    if (this.Instance && this.Instance.fail)
                        this.Instance.fail(this);
                })
                // Response has error
                .always(response => {
                    this.response = response;
                    if (this.Instance && this.Instance.always)
                        this.Instance.always(this);
                })
            ;
        }

    }
    App.Entities.Request = Request;
})();
